import { plainDate } from "@redotech/rpc/ext";
import * as z from "zod/v4";

const ForecastDataPoint_ = z.object({
  date: plainDate(),
  // Prediction values (null if no forecast for this date)
  prediction: z.number().nullable(),
  lowerBound: z.number().nullable(),
  upperBound: z.number().nullable(),
  // Actual sales value (null if no historical data for this date)
  actual: z.number().nullable(),
  // Days on hand at this date (null if no snapshot data available)
  daysOnHand: z.number().nullable(),
});

export const ForecastDataPoint: z.ZodType<ForecastDataPoint> =
  ForecastDataPoint_;
export interface ForecastDataPoint extends z.infer<typeof ForecastDataPoint_> {}

const GetSkuSalesForecastOutput_ = z.object({
  sku: z.string(),
  data: z.array(ForecastDataPoint),
});

export const GetSkuSalesForecastOutput: z.ZodType<GetSkuSalesForecastOutput> =
  GetSkuSalesForecastOutput_;
export interface GetSkuSalesForecastOutput
  extends z.infer<typeof GetSkuSalesForecastOutput_> {}

export const getSkuSalesForecast = {
  name: "getSkuSalesForecast" as const,
  input: z.object({
    sku: z.string(),
    startDate: plainDate(),
    endDate: plainDate(),
  }),
  output: GetSkuSalesForecastOutput,
};
